import { requestJson } from "../core/http.js";

const MAX_CACHED = 4;

export function toAudioUrl(base64, mime = "audio/wav") {
  const binary = globalThis.atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return URL.createObjectURL(new Blob([bytes], { type: mime }));
}

export class SpeechClient {
  constructor(apiBase, request = requestJson, decode = toAudioUrl) {
    this.apiBase = apiBase;
    this.request = request;
    this.decode = decode;
    this.cache = new Map();
  }

  get available() {
    return Boolean(this.apiBase);
  }

  remember(key, url) {
    this.cache.set(key, url);
    while (this.cache.size > MAX_CACHED) {
      const [oldest, value] = this.cache.entries().next().value;
      this.cache.delete(oldest);
      URL.revokeObjectURL?.(value);
    }
  }

  async clip(text, voice) {
    if (!this.available) throw new Error("Lettura vocale non configurata");
    const key = `${voice}::${text}`;
    if (this.cache.has(key)) return this.cache.get(key);
    const data = await this.request(`${this.apiBase}/api/speak`, {
      method: "POST",
      body: { text, voice },
      timeoutMs: 45000
    });
    if (!data?.audio) throw new Error("Audio non ricevuto");
    const url = this.decode(data.audio, data.mime || "audio/wav");
    this.remember(key, url);
    return url;
  }

  clear() {
    for (const url of this.cache.values()) URL.revokeObjectURL?.(url);
    this.cache.clear();
  }
}
